import { FC } from "react";

const AdminFooter: FC = () => {
  return (
    <footer className="text-center py-4 bg-gray-200">
      <div className="container mx-auto">
        <p>Copyright © 2025 Klub českých turistů. Created by ITIXO s.r.o.</p>
      </div>
    </footer>
  );
};

export default AdminFooter;
